import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaInseridoPor = (): TabelaColuna => ({
  Chave: 'inseridoPor',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 100 }}>Inserido Por</div>
})
